function isPrimaryRowAction(value) {
  return ['Details', 'Notification'].includes(value);
}

export { isPrimaryRowAction };
